// extracted by mini-css-extract-plugin
module.exports = {"noPointerEvents":"Explore_noPointerEvents_36kG-","mainViz":"Explore_mainViz_2IXWP","header":"Explore_header_5qahD","main":"Explore_main_12GNn","aside":"Explore_aside_1hu21"};